<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      :moreSearchVisible="true"
      permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        businessNumberOptions: [],
        form: [
          {
            label: '处理时间',
            value: 'yyyyMonth',
            type: 'date',
            placeholder: '请输入处理时间',
            default: new Date(),
            attr: {
              type: 'month',
            },
          },
          {
            label: '业务类型',
            value: 'businessNumber',
            type: 'select',
            default: -1,
          },
          {
            label: '订单号码',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号码',
          },
          {
            label: '操作时间',
            value: 'Time',
            type: 'date',
            placeholder: '请输入操作时间',
            attr: {
              type: 'daterange',
            },
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.Time && searchBoxData.Time.length) {
        searchBoxData.startTime = searchBoxData.Time[0];
        searchBoxData.endTime = searchBoxData.Time[1];
      }
      searchBoxData.yyyyMonth = this.formatDate(searchBoxData.yyyyMonth, 3);
      this.$refs.tableBox.saveSearchBoxData({
        userId: this.$route.query.id,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'ACCOUNT_DETAILS_BUSINESS_NUMBER',
    });
    this.searchBoxData.businessNumberOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
  },
};
</script>
<style lang="scss" scoped>
</style>
